export default __webpack_public_path__ + "images/4173d0a36c6ee1256898e92e8ed49022.svg";